import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

export const applicationIncome = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
}
